export function isAdmin(roles: string[]): boolean {
  if (!roles || roles.length == 0) {
    return false
  }

  return roles.some(r => ['icanow_admin_user', 'ProntoAdmin'].includes(r))
}

// TODO: Delete when all session data contains country code.
export function getCountryCode(countryCode: string | undefined, acr: string | undefined): string {
  if (countryCode) {
    return countryCode
  }

  switch (acr) {
    case 'icase-bankid-qr bankid':
    case 'icase-bankid-qr bankid test':
    case 'icase-bankid bankid':
    case 'icase-bankid bankid test':
      return 'SE'
    case 'FTN oidc':
      return 'FI'
    case 'iDIN oidc':
      return 'NL'
    case 'MitID oidc':
      return 'DK'
    case 'NorwegianBankID oidc':
      return 'NO'
    case 'Smart-ID oidc':
      return '' // Smart-ID is used in multiple countries, so we cannot determine the country code from the ACR.
    default:
      throw new Error(`Unknown acr: ${acr}. Cannot determine country code.`)
  }
}